import { inject, Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { SessionStorageService } from '../services/sessionl-storage.service';
import { User } from '../class/user.class';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);
  private router: Router = inject(Router);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    const token = route.queryParamMap.get('token');
    const usuario = route.queryParamMap.get('usuario');

    if (token && usuario) {

      const decoded: any = jwtDecode(token);
      const nameId = decoded["nameid"];
      const organismId = decoded["OrganismId"];

      const currentUser = {
        id: Number(usuario),
        userName: nameId,
        token,
        court: organismId,
        isAdmin: false
      };

      this.sessionStorageService.setItem('currentUser', currentUser);

      return true;
    }

    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
   const RutaFinal = this.router.getCurrentNavigation()?.finalUrl?.toString();
    if (currentUser && currentUser.active == 0 && (RutaFinal === '/home'|| RutaFinal?.includes('/itx') || RutaFinal === '/SelectCourt' || RutaFinal?.includes('/ChangeCourt'))) {
        return false;
        
    }
    
    const rutaActual = this.router.url;
    if (currentUser && currentUser.active == 1 && (RutaFinal === '/home'|| RutaFinal?.includes('/itx') || RutaFinal === '/ChangePassIni' || RutaFinal === '/AvisoPrivacidad' || RutaFinal?.includes('/ChangeCourt')) && rutaActual === '/SelectCourt' && currentUser.court === 0) {
        return false;        
    }
  if (currentUser && currentUser.userName === "usrSisePA" && (RutaFinal === '/home'|| RutaFinal?.includes('/itx') || RutaFinal === '/SelectCourt' || RutaFinal === '/ChangePassIni' || RutaFinal === '/AvisoPrivacidad' || RutaFinal?.includes('/ChangeCourt')) && rutaActual.includes('/ReporteAltaInstitucionesPublicas')) {
        return false;        
    }

    if (this.isLoggedIn()) {
      return true;
    }


    this.router.navigate(['/login']);
    return false;
  }

  public isLoggedIn(): boolean {
   /*let status = false;
    if (sessionStorage.getItem('currentUser')) {

      status = true;
    } else {
      status = false;
    }
    return status;*/
    const user = this.sessionStorageService.getItem<User>('currentUser');
    return user !== null && !!user.token;
  }
}


